enum ProcessResultKeyEnum {
    ACCOUNT_BLOCKED = "ACCOUNT_BLOCKED",
    ACCOUNT_NOT_ACTIVE = "ACCOUNT_NOT_ACTIVE",
    ACCOUNT_NOT_FOUND = "ACCOUNT_NOT_FOUND",
    AUTHORIZATION_BLOCKED = "AUTHORIZATION_BLOCKED",
    AUTHORIZATION_INVALID = "AUTHORIZATION_INVALID",
    OTP_LIMIT_REACHED = "OTP_LIMIT_REACHED",
    OTP_NOT_READY_YET = "OTP_NOT_READY_YET",
    OTP_PHONE_BLOCKED = "OTP_PHONE_BLOCKED",
    VERIFIED_MOBILE_NOT_FOUND = "VERIFIED_MOBILE_NOT_FOUND"
}

export default ProcessResultKeyEnum;
